var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('el-cascader',{attrs:{"clearable":"","size":_vm.size,"placeholder":_vm.placeholder,"options":_vm.options,"value":_vm.defaultModuleCode,"change-on-select":""},on:{"change":_vm.handleModuleCodeChange}}),_c('input',{staticStyle:{"display":"none"},attrs:{"type":"text"},domProps:{"value":_vm.value}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }